<template>
  <div class="trouble">
    <div v-if="index > -1">
      <div class="name">{{ troubles[index].name }}</div>
      <div class="hint">{{ this.$t("helpCenter.description") }}</div>
      <div class="des" v-html="troubles[index].des"></div>
      <div class="hint">{{ this.$t("helpCenter.solution") }}</div>
      <div class="sug" v-html="troubles[index].sug"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: -1,
      lang: this.$route.params.lang
    };
  },
  mounted() {
    this.$i18n.locale = this.lang;
    this.index = parseInt(this.$route.params.ti);
  },
  computed: {
    titles() {
      return this.$t("helpCenter.title");
    },
    troubles() {
      return this.$t("helpCenter.troubles");
    }
  }
};
</script>

<style lang="less" scoped>
.trouble {
  min-height: 100%;
  box-sizing: border-box;
  background: #111117;
  padding: 40px 32px;
  .name {
    color: #f2f2f2;
    font-weight: 500;
    margin-bottom: 24px;
  }
  .hint {
    color: #f2f2f2;
    margin-bottom: 8px;
  }
  .des {
    font-size: 14px;
    color: #c7cad1;
    margin-bottom: 16px;
    line-height: 21px;
  }
  .sug {
    font-size: 14px;
    color: #c7cad1;
    line-height: 21px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/help_multilingual/trouble.vue